import { render, staticRenderFns } from "./Right-sidebar.vue?vue&type=template&id=0d96f076&"
import script from "./Right-sidebar.vue?vue&type=script&lang=js&"
export * from "./Right-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports